import { render, staticRenderFns } from "./GroupStructure.vue?vue&type=template&id=d9b036c6&scoped=true&"
import script from "./GroupStructure.vue?vue&type=script&lang=js&"
export * from "./GroupStructure.vue?vue&type=script&lang=js&"
import style0 from "./GroupStructure.vue?vue&type=style&index=0&id=d9b036c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b036c6",
  null
  
)

export default component.exports